export var AutoRenameTypeEnum;
(function (AutoRenameTypeEnum) {
    AutoRenameTypeEnum[AutoRenameTypeEnum["None"] = 0] = "None";
    AutoRenameTypeEnum[AutoRenameTypeEnum["AutoIncrement"] = 1] = "AutoIncrement";
    AutoRenameTypeEnum[AutoRenameTypeEnum["NameGroupNameDataSourceName"] = 2] = "NameGroupNameDataSourceName";
    AutoRenameTypeEnum[AutoRenameTypeEnum["Replace"] = 3] = "Replace";
})(AutoRenameTypeEnum || (AutoRenameTypeEnum = {}));
